import { Injectable } from '@angular/core';
import { ApiConfig } from '../config/apiConfig';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfService } from 'src/conf.service';
import { Observable, BehaviorSubject } from 'rxjs';
import { tap, map } from 'rxjs/operators';
import { Workbook } from 'exceljs';
import * as fs from 'file-saver';
import { DatePipe } from '@angular/common';
@Injectable({
  providedIn: 'root'
})
export class ReportsService {
  datePiepe = new DatePipe('en-US');
  
  private rootUrl: string;
  private reportsAPIUrl;
  constructor(private http: HttpClient) {
    this.rootUrl = ConfService.conf.environment.apiRootUrl;
    this.reportsAPIUrl = ApiConfig.ReportsApiConfig;
    
   }

  	
	columnDefinitions(reportsObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.reportsAPIUrl.columnDefinitions}`, reportsObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	getReports(reportsObj:any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.reportsAPIUrl.getReports}`, reportsObj )
      .pipe(
        tap(() => {
          //
        })
      );
	}
	
	runReport(reportsObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.reportsAPIUrl.runReport}`, reportsObj )
      .pipe(
        tap(() => {
          //
        })
      );
	}

  //Start:Added By Harikesh on 06-Aug-2020 Export to exce from JSON
  exportExcel(excelData,fileName:string) {
    console.log(excelData);
    
    //Title, Header & Data
    const title = excelData.title;
    const columns = excelData.columns
    const data:any[] = excelData.data;
    const columnOrder=excelData.columnOrder;
    const groupColumns=excelData.groupColumns;
    //Create a workbook with a worksheet
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet('Report Data');

    //Adding Header Row
    let headerRow = worksheet.addRow([]);
    let index=1;
    for(let hdr of columnOrder )
    {
      if(columns[hdr]!=null && columns[hdr]!=undefined)
      {
        headerRow.getCell(index).value=columns[hdr].label
       
      }
      else
      {
        headerRow.getCell(index).value= hdr
      }
      index++;
    }
    headerRow.eachCell((cell, number) => {
      cell.font = {
        bold: true,
        color: { argb: '' },
        size: 10
      }
    })
    //Group Row 
    if(groupColumns.length>0)
    {
      let groupRow = worksheet.addRow([]);
      index=0
      for(let grpColumn of groupColumns )
      {
        if(data!=null && data.length>0)
        {
          groupRow.getCell(1).value=data[0].row[grpColumn]
          index++;
        }
      }
    }
    // Adding Data with Conditional Formatting
    data.forEach(d =>
    {
     if(groupColumns.length>0 && (d.row["Seq"]!=undefined && d.row["Seq"]>1)
       && (d.row["Rank"]!=undefined && d.row["Rank"]==1)){
      let groupRow = worksheet.addRow([]);
      index=0
      for(let grpColumn of groupColumns )
      {
        if(data!=null && data.length>0)
        {
          groupRow.getCell(1).value=d.row[grpColumn];    
          index++;
        }
      }
     }

      let row = worksheet.addRow([]);
      let cellindex=1;
      for(let hdr of columnOrder )
       {
         let cellValue=d.row[hdr]
         let cellType=columns[hdr].type.toLowerCase();
        
         if(hdr == "DrawDate" ){
          cellValue=this.datePiepe.transform(cellValue, "MM/dd/yyyy","local");
         }
         if(cellType=="date")
         {
          cellValue=this.datePiepe.transform(cellValue, "MM/dd/yyyy");
        }
         else if(cellType=="datetime")
         {
          cellValue=this.datePiepe.transform(cellValue, "MMM/dd/yyyy HH:mm:ss");
         }
         row.getCell(cellindex).value=cellValue
         row.getCell(cellindex).font = {
          bold: false,
          color: { argb: '' },
          size: 10
        }
         cellindex++;
       }
    });
    //Generate & Save Excel File
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, fileName);
    })

  }

}
